import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";

export function PoliticasPage() {
  return (
    <div className='min-h-screen bg-[#f6f8fb] text-slate-800 flex flex-col'>
      <NavBar isLogged={false} />

      <header className='bg-linear-to-r from-primary to-primary-hover text-white'>
        <div className='mx-auto max-w-5xl px-6 py-10'>
          <p className='text-xs uppercase tracking-[0.12em] text-white/80'>
            Legal
          </p>
          <h1 className='text-3xl font-bold'>Política de Privacidad</h1>
          <p className='mt-2 text-sm md:text-base text-white/90'>
            Última actualización: 23 de abril de 2026
          </p>
        </div>
      </header>

      <main className='flex-1'>
        <section className='mx-auto max-w-5xl px-6 py-12'>
          <div className='bg-white rounded-lg shadow-sm border border-slate-200 p-8 space-y-8'>
            
            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>1. Descripción</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Servix es una plataforma digital de servicios a domicilio operada por NUOVOCELL. 
                Esta política describe cómo recopilamos, usamos y protegemos su información personal al utilizar nuestra aplicación y el sitio web https://servix.com.ve/.
              </p>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>2. Información que Recopilamos</h2>
              <ul className='list-disc pl-5 text-sm leading-6 text-slate-700 space-y-1'>
                <li><strong>Registro:</strong> Nombre, correo electrónico, teléfono y contraseña.</li>
                <li><strong>Perfil:</strong> Dirección, datos del vehículo (clientes) o información del negocio (proveedores).</li>
                <li><strong>Uso:</strong> Solicitudes de servicio, historial, calificaciones y reseñas.</li>
                <li><strong>Ubicación:</strong> Ubicación aproximada durante el uso activo para conectar usuarios.</li>
                <li><strong>Pagos:</strong> Comprobantes cargados manualmente; no almacenamos datos bancarios directos.</li>
                <li><strong>Técnicos:</strong> Tipo de dispositivo, logs de errores y datos de rendimiento.</li>
              </ul>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>3. Uso de la Información</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Utilizamos sus datos para facilitar la conexión entre clientes y proveedores, gestionar solicitudes, 
                enviar notificaciones de estado, mejorar la aplicación y cumplir con obligaciones legales.
              </p>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>4. Compartición de Datos</h2>
              <p className='text-sm leading-6 text-slate-700'>
                No vendemos información personal. Compartimos datos únicamente entre usuarios para coordinar servicios, 
                con AWS para infraestructura segura o por requerimiento legal.
              </p>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>5. Seguridad y Almacenamiento</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Los datos se almacenan en servidores cifrados de AWS. Implementamos controles de acceso y backups, 
                aunque recordamos que ningún sistema es 100% infalible.
              </p>
            </div>

            <div>
              <h2 className='text-lg font-bold mb-3 text-primary'>6. Sus Derechos</h2>
              <p className='text-sm leading-6 text-slate-700'>
                Usted tiene derecho a acceder, corregir o eliminar sus datos personales. 
                Puede retirar su consentimiento o solicitar la eliminación de su cuenta escribiendo a <strong>admin@servix.com.ve</strong>.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}